// extracted by mini-css-extract-plugin
export default {"dropdownOverlay":"CompletionFilter_dropdownOverlay__Cb5Vi","clearMenuItem":"CompletionFilter_clearMenuItem__jW5MQ"};